
import { showToast } from "../utils";
import { apiTaxesv2 } from "../services/Api"


export function useTaxesV2() {
  const baseUrlBrands = `service/tax/brands`
  const baseUrlSeller = `service/tax/seller`
  const baseUrlHistory = `service/tax/history/seller`
  const baseUpdate = `/service/tax/update`


  const updateSellerRates = async (item?: object) => {
    try {
      const response = await apiTaxesv2.put(`${baseUpdate}`, item)
      return response
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao carregar"
      })
    }
  }
  async function getRateBrands(search?: string) {
    try {
      const response = await apiTaxesv2.get(`${baseUrlBrands}`, {})
      return response.data
    } catch (error) {
      return error
    }
  }


  const getRateSeller = async (search?: string) => {
    try {
      const response = await apiTaxesv2.get(`${baseUrlSeller}`, {})

      return response.data
    } catch (error) {
      return error
    }
  }


  async function getHistorySeller(id?: string) {

    try {
      const response = await apiTaxesv2.get(`${baseUrlHistory}`, {})
      return response.data
    } catch (error) {
      return error
    }
  }

  async function getUrlSigned(id?: number) {
    const baseUrlHistorySigned = `service/tax/history/${id}/signed-url`
    try {
      const response = await apiTaxesv2.get(`${baseUrlHistorySigned}`, {
        headers: {
          Cookie: 'AWSALB=wRcql0prsNEBMEOHHnH2PiXuSktsh5m7uVpCVF5dCKA0MGntbc/aqc2k2y6zYcHWi3fzae7nW0HxNWRccGrYZv2Ej2WPqylwIChow8yTKMfvF/MgBz4pqId+0ygGKZo2QqFbx/RF6SHhJMbII0vL5VenaFqx/sd7YgQjKN6WwTCedAu+TGpfoIKuS/s4MQ==; AWSALBCORS=wRcql0prsNEBMEOHHnH2PiXuSktsh5m7uVpCVF5dCKA0MGntbc/aqc2k2y6zYcHWi3fzae7nW0HxNWRccGrYZv2Ej2WPqylwIChow8yTKMfvF/MgBz4pqId+0ygGKZo2QqFbx/RF6SHhJMbII0vL5VenaFqx/sd7YgQjKN6WwTCedAu+TGpfoIKuS/s4MQ==',
        },
      })
      return response.data
    } catch (error) {
      console.error("Error fetching signed URL:", error);
      throw error;
    }
  }

  return {
    getRateBrands,
    getRateSeller,
    getHistorySeller,
    getUrlSigned,
    updateSellerRates
  }
}